import { render, staticRenderFns } from "./empty-box.vue?vue&type=template&id=79ca88b3&scoped=true"
import script from "./empty-box.vue?vue&type=script&lang=js"
export * from "./empty-box.vue?vue&type=script&lang=js"
import style0 from "./empty-box.vue?vue&type=style&index=0&id=79ca88b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca88b3",
  null
  
)

export default component.exports